<template>
  <!-- 主要内容 begin -->
  <div id="content-main" style="">
    <div style="font-size:30px">
      <img
        src="../../assets/404.png"
        style="width:100%; max-width:846px; margin:5% auto; display:block;"
      />
    </div>
  </div>
  <!-- 主要内容 end -->
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>
